'use es6';

import PropTypes from 'prop-types';
import React from 'react';
import I18n from 'I18n';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIModal from 'UIComponents/dialog/UIModal';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';

var ReviewModalSuccess = function ReviewModalSuccess(_ref) {
  var closeReviewModal = _ref.closeReviewModal;
  return React.createElement(UIModal, {
    size: "auto",
    use: "success"
  }, React.createElement(UIDialogHeader, null, React.createElement(UIDialogCloseButton, {
    onClick: closeReviewModal
  }), React.createElement(H2, null, I18n.text('reviewModal.reviewSubmitted.header'))), React.createElement(UIDialogBody, null, I18n.text('reviewModal.reviewSubmitted.description')), React.createElement(UIDialogFooter, null, React.createElement(UIButton, {
    use: "primary",
    onClick: closeReviewModal
  }, I18n.text('reviewModal.reviewSubmitted.button'))));
};

ReviewModalSuccess.propTypes = {
  closeReviewModal: PropTypes.func.isRequired
};
export default ReviewModalSuccess;